import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    //------------- globalStates
    globalStates,
    //------------- defalutData 
    defaultData,
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData
}) => {

    // Para redirigir a otras pantallas
    const navigate = useNavigate();

    const abrirModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }

    const cerrarModal = () => {
        toggle()
    }

    const handleClickShowForm = () => {
        const { setShowForm } = globalStates
        setShowForm(true)
    }

    const handleClickHideForm = () => {

        const { setShowForm } = globalStates
        const { FormScreen } = Forms
        const { onResetForm } = FormScreen
        const { fetchAllCashRegisters } = FetchData

        onResetForm()
        fetchAllCashRegisters.resetFetch()
        setShowForm(false)


    }

    const handleClickDeleteOperation = async (idasignacion) => {

        const { fetchOperationsByUser } = FetchData

        Swal.fire({
            title: '¿Está seguro de eliminar este registro?',
            text: 'Esta acción no se puede deshacer, haga click en "Eliminar" para continuar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Eliminar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/cashier-operations/delete-operation/${idasignacion}`)
                .then(({ data }) => {
                    
                    alertMessage(data)
                    fetchOperationsByUser.executeFetch()
                    cerrarModal()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
        
    }

    const handleClickFetchSpecificOperation = async (idoperacion) => {
        
        const { FormScreen: { onResetForm } } = Forms

        const { fetchSpecificOperation } = FetchData
        const { setParamsToSearch, executeFetch } = fetchSpecificOperation

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({
            idoperacion: idoperacion
        })
        executeFetch()

        handleClickShowForm()

    }

    const handleClickEnableDisableOperation = async (idoperacion, estado) => {

        const { fetchOperationsByUser } = FetchData

        Swal.fire({
            title: '¿Está seguro de cambiar el estado de este registro?',
            text: 'Esta acción hará que el registro vuelva a mostrarse en los listados de casas que se encuentran en todo el sistema y podrá asociar información a él nuevamente',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Continuar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.post(`/cashier-operations/enable-disable-operation`, { idoperacion, estado })
                    .then(({ data }) => {
                        
                        alertMessage(data)
                        fetchOperationsByUser.executeFetch()

                    })
                    .catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
    }

    const handleClickMakeOperation = async (idoperaciones) => {
        navigate(`/cajas/operaciones/detalles/${idoperaciones}`)
    }

    const onSubmitForm = async (e) => {

        e.preventDefault()

        const { fetchOperationsByUser } = FetchData
        const { setLoadingSubmitForm } = globalStates
        const { FormScreen } = Forms
        const { formState, onResetForm } = FormScreen

        if (
            formState.fecha_operacion === ''
            || formState.currency_type === ''
            || formState.idcaja === ''
        ){
            alertMessage({
                flag: false,
                message: 'Para registrar la transacción debe completar todos los campos del formulario'
            })
            return
        }

        const _dataBody = {
            idoperacion: formState.idoperacion,
            idcaja: formState.idcaja,
            idusuario: user.uid,
            fecha_operacion: formState.fecha_operacion,
            user: user.username
        }


        console.log('[useActions][onSubmitForm] _dataBody ', _dataBody)
        setLoadingSubmitForm(true)
        await marvarApi.post(`/cashier-operations/create-operation`, _dataBody)
            .then(({ data }) => {

                console.log('data ::: ', data)

                alertMessage(data)

                if (data.flag === 'FAIL'){
                    setLoadingSubmitForm(false)
                    return
                }
                
                onResetForm()
                handleClickHideForm()
                setLoadingSubmitForm(false)

                fetchOperationsByUser.executeFetch()

            })
            .catch(error => {
                setLoadingSubmitForm(false)
                console.log('API ERROR: ', error)
            })
    }

    return Object.freeze({
        abrirModal,
        cerrarModal,
        handleClickShowForm,
        handleClickHideForm,
        handleClickDeleteOperation,
        handleClickFetchSpecificOperation,
        handleClickEnableDisableOperation,
        handleClickMakeOperation,
        onSubmitForm
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { flag, message } = res
        if (flag === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}